<template>
    <section>
        <div class="copy-wrapper">
            <vue-tags-input
                    :id="tagInputId"
                    v-model="tag"
                    :tags="tags"
                    :add-on-key="[32, 13]"
                    placeholder="Type or paste hashtags here..."
                    @before-adding-tag="checkTag"
                    @adding-duplicate="duplicateWarning"
                    @before-deleting-tag="beforeDelete"
                    :separators="[' ']"
                    @keyup.native.delete="onDelete"
                    @tags-changed="tagsChanged"
                    :delete-on-backspace="true"
                    :validation="validation"
            />
            <b-tooltip :show.sync="duplicateTagEntered" ref="tooltip" :target="tagInputId" triggplacement="top"
                       triggers="manual">This hashtag is already added
            </b-tooltip>


            <div class="btn-bar">
                    <b-btn v-if="bannedinsta" variant="primary" class="hashtag-btn"
                           @click="removeBannedInsta">
                        <font-awesome-icon :icon="['far', 'trash-alt']"/>
                        Banned on Instagram
                    </b-btn>
                    <b-btn v-if="save" variant="outline-secondary" class="hashtag-btn"
                           @click="saveHashtag">
                        <font-awesome-icon :icon="['far', 'bookmark']"/>
                        Save
                    </b-btn>
                    <b-btn variant="secondary" v-if="saveset && loading" disabled>
                        Saving...
                    </b-btn>
                    <b-btn v-if="saveset && !loading" variant="outline-primary"
                           class="hashtag-btn" @click="saveHashtagSet">
                        Save changes
                    </b-btn>
                    <b-btn v-if="compare" variant="outline-secondary" class="hashtag-btn"
                           @click.native="compareHashtags" to="/hashtag-comparison">
                        <font-awesome-icon :icon="['far', 'chart-bar']"/>
                        Compare
                    </b-btn>
                    <b-btn v-if="load" variant="outline-secondary" class="hashtag-btn" v-b-modal.modal2>
                        <font-awesome-icon :icon="['ritetag', 'ritetagHashtagSet']"/>
                        Load Hashtag Set
                    </b-btn>
                    <b-btn v-if="instagram" variant="outline-secondary" class="hashtag-btn"
                           id="removeInsta" @click="removeInstaTags">
                        <font-awesome-icon :icon="['far', 'trash-alt']"/>
                        Instagram
                    </b-btn>
                    <b-btn v-if="banned" variant="outline-secondary" class="hashtag-btn" id="removeBad"
                           @click="removeBadTags">
                        <font-awesome-icon :icon="['far', 'trash-alt']"/>
                        Unused & Banned
                    </b-btn>
                    <b-btn v-if="copy" variant="outline-secondary" class="hashtag-btn"
                           @click="copyHashtagNames">
                        <font-awesome-icon :icon="['far', 'copy']"/>
                        Copy
                    </b-btn>
                    <b-btn v-if="clear" variant="outline-secondary" class="hashtag-btn"
                           @click="cleartext">
                        <font-awesome-icon :icon="['fas', 'undo']"/>
                        Clear
                    </b-btn>
                    <!-- TODO: Add delete set button and enable it only for hashtag input in Hashtag Sets screen  -->
                    <b-btn v-if="deleteset" variant="outline-secondary" class="hashtag-btn"
                           @click="deleteHashtagSet">
                        <font-awesome-icon :icon="['far', 'trash-alt']"/>
                        Delete set
                    </b-btn>
                <b-modal title="Save hashtag set" id="modal1" centered ref="modal1" hide-footer>
                    <SaveHashtagSet :hashtagSet='this.tags'/>
                </b-modal>
                <b-modal title="Add hashtag sets" id="modal2" hide-footer>
                    <AddHashtagSet v-on:addedHashtagSet="addHashtagSets($event)"/>
                </b-modal>

            </div>
        </div>
        <div class="alert alert-success" v-if="removedbanned">
            <div>{{removedHashtags}}</div>
        </div>
    </section>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {VueTagsInput} from '@johmun/vue-tags-input'
    import AddHashtagSet from './AddHashtagSet'
    import hashtags from '../../mixins/hashtags'
    import SaveHashtagSet from "./SaveHashtagSet";
    import {api} from '../../_services/ritetag'
    import uuid from 'uuid/v4'

    // const COLOR_UNUSED = 0
    // const COLOR_OVERUSED = 1
    // const COLOR_POOR = 2
    // const COLOR_GOOD = 3
    // const COLOR_INSTAGRAM = 4
    // const COLOR_INSTAGRAM_BANNED = 5
    // const colors = ['unused', 'overused', 'poor', 'good', 'instagram', 'instagram-banned']

    export default {
        name: 'HashtagInput',
        props: [
            'value',
            'suggestedHashtags',
            'hashtags',
            'sets',
            'save',
            'saveset',
            'deleteset',
            'savesetname',
            'hashtagsetid',
            'compare',
            'load',
            'instagram',
            'banned',
            'bannedinsta',
            'clear',
            'copy'
        ],
        mixins: [hashtags],
        components: {
            VueTagsInput,
            AddHashtagSet,
            SaveHashtagSet
        },
        data() {
            return {
                tagInputId: 'tag-input-' + uuid(),
                tag: '',
                // tags: [],
                loading: false,
                duplicateTagEntered: false,
                removedHashtags: '',
                removedbanned: false,
                validation: [{
                    rule: tag => this.containsTag(tag.text.length),
                    classes: 'ti-duplicate',
                    disableAdd: true
                }]
            }
        },
        methods: {
            ...mapActions('comparison', [
                'setResetComparison',
                'setAddToComparison'
            ]),
            ...mapActions('stats', {
                getStatsInfo: 'get',
            }),
            ...mapActions('hashtagSets', [
                'setDeleteSet'
            ]),
            tagsChanged (newTags) {
                // console.log('newTags')
                // console.log(newTags)
            },
            compareHashtags() {
                this.setResetComparison()
                const tags = this.suggestedHashtags.map(i => this.removeHashmark(i.hashtag || i.name))
                this.getStatsInfo(tags).then(() => {
                    tags.map(x => this.getHashtag[x]).forEach(this.setAddToComparison)
                })
            },
            saveHashtag () {
                this.$refs['modal1'].show()
            },
            saveHashtagSet () {
                this.loading = true
                api.tagsetCreate({
                        name: this.savesetname,
                        tags: this.tags.map(x => x.text),
                        merge: 0
                    }
                ).then((response) => {
                    this.loading = false;
                    this.$notify({type: 'success', text: 'Changes saved.'})
                }).catch((err) => {
                    this.$notify({
                        type: 'error',
                        text: 'Oops! There was an error. Check your internet connection and refresh the page'
                    })
                })
            },
            checkTag (obj) {
                let hashtag = obj.tag.text;
                obj.tag.classes = 'ti-unused'
                if (hashtag.includes("#")) {
                    hashtag = hashtag.split("#").pop();
                }
                obj.tag.text = hashtag
                if (this.getBookmarkedHashtags.map(x => x.hashtag).indexOf(hashtag) > -1) {
                    this.duplicateTagEntered = true
                    return
                }
                obj.addTag()
                this.getStatsInfo(hashtag).then(() => {
                    const data = this.getHashtag[hashtag]
                    this.$emit('added', this.getHashtag[hashtag])
                    obj.tag.classes = this.getClass(data.color)
                })
                this.duplicateTagEntered = false
            },
            duplicateWarning() {
                this.duplicateTagEntered = true
            },
            onDelete() {
                this.duplicateTagEntered = false
            },
            beforeDelete(obj) {
                if (this.hashtagsetid == null) {
                    this.getBookmarkedHashtags.forEach(x => {
                        if (x.hashtag === obj.tag.text) {
                            this.getBookmarkedHashtags.splice(x, 1)
                        }
                    })
                    this.removeTag(obj.tag.text)
                } else {
                    this.removeTag(obj.tag.text)
                }
                obj.deleteTag()
            },
            removeTag (tag) {
                for(let i in this.suggestedHashtags) {
                    let x = this.suggestedHashtags[i]
                    if (this.removeHashmark(x.hashtag || x.name) === tag) {
                        this.suggestedHashtags.splice(i, 1)
                        return true
                    }
                }
                return false
            },
            containsTag (tag) {
                for(let i in this.suggestedHashtags) {
                    let x = this.suggestedHashtags[i]
                    if (this.removeHashmark(x.hashtag || x.name) === tag) {
                        return true
                    }
                }
                return false
            },
            cleartext() {
                while(this.suggestedHashtags.pop()) {}
                this.$emit('clear')
            },
            removeBannedInsta() {
                let hashtagString = ''
                for (let i = 0; i < this.tags.length; i++) {
                    hashtagString += ("#" + this.tags[i].text + " ")
                }
                this.loading = true
                const params = new URLSearchParams()
                params.append('post', hashtagString)
                api.instagramCleaner(params)
                    .then((response) => {
                        this.loading = false
                        this.setRemovedHashtags(response.data.bannedHashtags)
                        hashtagString = ''
                    }).catch(error => {
                    this.loading = false
                    this.setRemovedHashtags([])
                })
            },
            setRemovedHashtags(bannedHashtag) {
                this.removedbanned = true
                this.removedHashtags = ''
                if (bannedHashtag.length === 0) {
                    this.removedHashtags = 'No hashtags are banned!'
                    return
                } else {
                    bannedHashtag.forEach(h => {
                        this.removedHashtags += `${h} `
                        for (let i = 0; i < this.tags.length; i++) {
                            if (this.tags[i].text === h.slice(1)) {
                                this.removeTag(this.tags[i].text)
                            }
                        }
                    })
                    if (bannedHashtag.length === 1) {
                        this.removedHashtags += 'is banned on Instagram and was removed.'
                    } else {
                        this.removedHashtags += 'are banned on Instagram and were removed.'
                    }
                }
            },
            removeBadTags() {
                const tags = this.getHashtagsByClasses([0, 5])
                tags.forEach(this.removeTag)
                if (tags.length === 0) {
                    this.$notify({type: 'success', text: 'No more bad hashtags to remove'})
                }
            },
            removeInstaTags() {
                const tags = this.getHashtagsByClasses([4])
                tags.forEach(this.removeTag)
                if (tags.length === 0) {
                    this.$notify({type: 'success', text: 'No more instagram hashtags to remove'})
                }
            },
            getHashtagsByClasses (classes) {
                return this.suggestedHashtags
                    .filter(x => classes.indexOf(x.color || x.colorCode) > -1)
                    .map(x => this.removeHashmark(x.hashtag || x.name))
            },
            copyHashtagNames() {
                const selectedHashtags = []
                this.tags.forEach(x => {
                    selectedHashtags.push(x.text)
                })
                this.$notify({type: 'success', text: 'Hashtags copied to clipboard.'})
                const text = selectedHashtags.map(x => `#${x}`).join(' ')
                this.$clipboard(text)
            },
            addedHashtagSet(newSet) {
                for (let hashtag in newSet) {
                    this.hashtags.push({
                        name: newSet[hashtag],
                        classObject: {'tagstyleBig': true, 'good': true},
                        selected: true
                    })
                }
                this.hashtags.pop()
            },
            addHashtagSets(tagset) {
                this.suggestedHashtags.push(...tagset.filter(x => !this.containsTag(this.removeHashmark(x.name))))
            },
            getClass(color) {
                return [
                    'ti-unused',
                    'ti-overused',
                    'ti-poor',
                    'ti-good',
                    'ti-instagram',
                    'ti-instagram-banned'
                ][color]
            },
            removeHashmark(hashtag) {
                if (hashtag.substring(0, 1) === '#') {
                    return hashtag.slice(1)
                }
                return hashtag
            },
            deleteHashtagSet () {
                this.setDeleteSet(this.hashtagsetid).then(() => {
                    this.$notify({type: 'success', text: 'Hashtag set was deleted.'})
                })
            }
        },
        computed: {
            ...mapGetters('comparison', ['getBookmarkedHashtags']),
            ...mapGetters('stats', {
                getHashtag: 'getHashtag'
            }),
            tags () {
                return this.suggestedHashtags.sort((a, b) => {
                    const colors = [6, 3, 2, 1, 4, 5];
                    const colorA = colors[a.color || a.colorCode]
                    const colorB = colors[b.color || b.colorCode]
                    return colorA - colorB
                }).map(x => {
                    return {
                        text: this.removeHashmark(x.hashtag || x.name),
                        classes: this.getClass(x.color || x.colorCode)
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .copy-wrapper {
        display: grid;

        .tag-button {
            position: relative;
            display: inline-block;
        }

        .vue-tags-input {
            max-width: 100% !important;
            display: inline-block;
            width: 100%;

            .ti-input {
                border-radius: 0.25rem;
            }

            .ti-tag {
                font-size: 1em;

                &:before {
                    content: '#';
                }

                &.ti-good {
                    background-color: $good;
                }

                &.ti-poor {
                    background-color: $poor;
                }

                &.ti-overused {
                    background-color: $overused;
                }

                &.ti-unused {
                    background-color: $unused;
                }

                &.ti-instagram-banned {
                    background-color: $instagram-banned;
                }

                &.ti-instagram {
                    background: $instagram-moz;
                    background: $instagram-webkit;
                    background: $instagram;
                }
            }
        }

        .btn-bar {
            margin-top: 5px;
            line-height: 40px;
            display: -webkit-inline-box;

            .btn {
                margin-right: 3px;
            }
        }
    }

    .alert.alert-success {
        margin-top: 10px;
    }
</style>
